// Tenantra Inc. - AI-written portfolio summary at the top of Analytics (Claude via the Emergent LLM key, cached server-side)
import { useCallback, useEffect, useRef, useState } from 'react';
import { RefreshCw, Sparkles } from 'lucide-react';
import api, { apiHelpers } from '@/services/api';

export function AiSummary({ scope }) {
  const [s, setS] = useState({ loading: true });
  const req = useRef(0);
  const load = useCallback((refresh = false) => {
    const id = ++req.current;
    setS((x) => ({ ...x, loading: true, error: null }));
    api.get('/landlord/analytics/summary', { params: { ...scope, ...(refresh ? { refresh: true } : {}) } })
      .then(r => { if (id === req.current) setS({ ...r.data, loading: false }); })
      .catch(e => { if (id === req.current) setS({ loading: false, error: apiHelpers.handleError(e) }); });
  }, [scope]);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="rounded-lg bg-gradient-to-br from-teal-50/70 to-white border border-teal-100 px-5 py-4" data-testid="ai-summary">
      <div className="flex items-center justify-between gap-3 mb-2">
        <p className="text-xs font-medium text-teal-800 inline-flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5" /> Summary</p>
        <button type="button" onClick={() => load(true)} disabled={s.loading} className="text-[11px] text-teal-700 hover:text-teal-900 inline-flex items-center gap-1 disabled:opacity-50 transition-colors" data-testid="ai-summary-refresh">
          <RefreshCw className={`w-3 h-3 ${s.loading ? 'animate-spin' : ''}`} /> Refresh
        </button>
      </div>
      {s.loading && !s.text ? (
        <div className="space-y-2" data-testid="ai-summary-loading">{[92, 84, 60].map(w => <div key={w} className="h-3 bg-teal-100/60 rounded animate-pulse" style={{ width: `${w}%` }} />)}</div>
      ) : s.error ? (
        <p className="text-sm text-slate-500" data-testid="ai-summary-error">{s.error}</p>
      ) : (
        <>
          <p className={`text-sm leading-relaxed text-slate-700 transition-opacity ${s.loading ? 'opacity-50' : ''}`} data-testid="ai-summary-text">{s.text}</p>
          <p className="text-[11px] text-slate-400 mt-2">Written by AI from the numbers on this page · {new Date(s.generated_at).toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</p>
        </>
      )}
    </section>
  );
}
